import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import React from 'react';

interface IWinPercentage {
  winningPercentage?: number;
}

const WinPercentage: React.FC<IWinPercentage> = ({ winningPercentage = 0 }) => (
  <StyledText className={Font.f12_bold_tall}>
    {(winningPercentage ?? 0 * 100).toFixed(2)}
    <StyledText className={Font.f12_tall} $color={THEME.text.tertiary}>
      {` Win %`}
    </StyledText>
  </StyledText>
);

export default WinPercentage;
